<template>
  <div class="rightside" :style="isShow" v-if="!isChatGPTPage">
    <!-- <div :class="'rightside-config-hide ' + isOut">
      <i :class="'iconfont rightside-icon ' + icon" @click="check" />
    </div> -->
    <!-- <div class="setting-container" @click="show">
      <i class="iconfont iconshezhi setting" />
    </div> -->
    <!-- <div class="setting-container">
      <i :class="simplifyIcon" @click="simplifyCheck" />
    </div> -->
    <i @click="backTop" class="iconfont rightside-icon-up mdi mdi-arrow-up"></i>
    <i
      @click="backBottom"
      class="iconfont rightside-icon-down mdi mdi-arrow-down"
    ></i>
  </div>
</template>

<script>
import { userConfigGet, getUserSkill } from "../api";
export default {
  mounted() {
    this.getConfig();
    window.addEventListener("scroll", this.scrollToTop);
    // 检查当前路由
    this.isChatGPTPage =
      this.$route.path.includes("/ai/chatgpt") && !this.isMobile;

    // 监听路由变化
    this.$watch(
      () => this.$route.path,
      (newPath) => {
        this.isChatGPTPage = newPath.includes("/ai/chatgpt") && !this.isMobile;
      }
    );
  },
  destroyed() {
    window.removeEventListener("scroll", this.scrollToTop);
  },
  data: function() {
    return {
      isShow: "",
      isOut: "rightside-in",
      icon: "iconyueliang",
      isSimplify: false,
      // simplifyIcon: "mdi mdi-server-plus",
      isChatGPTPage: false,
    };
  },
  computed: {
    isMobile() {
      const clientWidth = document.documentElement.clientWidth;
      if (clientWidth > 760) {
        return false;
      }
      return true;
    },
  },
  methods: {
    getConfig() {
      userConfigGet({})
        .then((res) => {
          this.$store.commit("checkConfigInfo", res.data);
          // if (res.data.theme.themeMode == "light") {
          //   this.$vuetify.theme.dark = false;
          // } else if (res.data.theme.themeMode == "dark") {
          //   this.$vuetify.theme.dark = true;
          // }
        })
        .catch((err) => {});

      getUserSkill({})
        .then((res) => {
          this.$store.commit("checkSkillInfo", res.data);
          // console.log(this.$store.state.skillInfo);
        })
        .catch((err) => {});
    },
    openFeedback() {
      this.$store.commit("setDialogFormVisible");
    },
    // 回到顶部方法
    backTop() {
      window.scrollTo({
        behavior: "smooth",
        top: 0,
      });
    },
    // 回到底部方法
    backBottom() {
      window.scrollTo({
        behavior: "smooth",
        top: document.body.scrollHeight,
      });
    },

    // 为了计算距离顶部的高度，当高度大于100显示回顶部图标，小于100则隐藏
    scrollToTop() {
      const that = this;
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      that.scrollTop = scrollTop;
      if (that.scrollTop > 20) {
        that.isShow = "opacity: 1;transform: translateX(-38px);";
      } else {
        that.isShow = "";
      }
    },
    show() {
      const flag = this.isOut == "rightside-out";
      this.isOut = flag ? "rightside-in" : "rightside-out";
    },
  },
};
</script>

<style scoped>
.rightside {
  z-index: 4;
  position: fixed;
  right: -38px;
  bottom: 130px;
  transition: all 0.5s;
}
.rightside-config-hide {
  transform: translate(35px, 0);
}
.rightside-out {
  animation: rightsideOut 0.3s;
}
.rightside-in {
  transform: translate(0, 0) !important;
  animation: rightsideIn 0.3s;
}
.rightside-icon-up {
  display: block;
  width: 30px;
  height: 18px;
  background-color: #49b1f5;
  color: #fff;
  text-align: center;
  font-size: 12px;
  line-height: 18px;
  cursor: pointer;
  border-radius: 10px 0px 0px 0px;
}
.rightside-icon-down {
  display: block;
  width: 30px;
  height: 18px;
  background-color: #49b1f5;
  color: #fff;
  text-align: center;
  font-size: 12px;
  line-height: 18px;
  cursor: pointer;
  border-radius: 0px 0px 0px 10px;
}
.setting-container {
  display: block;
  margin-bottom: 2px;
  width: 30px;
  height: 30px;
  background-color: #49b1f5;
  color: #fff;
  text-align: center;
  font-size: 16px;
  line-height: 30px;
  cursor: pointer;
  border-radius: 10px 0px 0px 10px;
}
.rightside-icon-up:hover,
.rightside-icon-down:hover,
.setting-container:hover {
  background-color: #ff7242;
}
.setting-container i {
  display: block;
  /* animation: turn-around 2s linear infinite; */
}
@keyframes turn-around {
  0% {
    transform: rotate(0);
  }
  100% {
    transform: rotate(360deg);
  }
}
@keyframes rightsideOut {
  0% {
    transform: translate(0, 0);
  }
  100% {
    transform: translate(30px, 0);
  }
}
@keyframes rightsideIn {
  0% {
    transform: translate(30px, 0);
  }
  100% {
    transform: translate(0, 0);
  }
}
</style>
